import type { RevisionExt } from "@/components/widgets/Revision/types";

export const todayData = (
	dataCollection: RevisionExt[],
): RevisionExt | undefined => {
	if (!dataCollection || dataCollection.length === 0) {
		return undefined;
	}

	let i = dataCollection.length - 1;
	while (i >= 0 && dataCollection[i]?.dp?.ns?.ee === undefined) {
		i--;
	}

	return i >= 0 ? dataCollection[i] : undefined;
};
